import { createMergeReducer } from '../utils/reducer'
import { CollectionDetail } from './collections'

export type TitleIdToBundleCarousel = {
  [titleId: string]: CollectionDetail | undefined
}

export const reducer = createMergeReducer(
  t => t.bundleCarousel,
  {} as TitleIdToBundleCarousel
)
